import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../shared/shared.module';
import { PickAdvertiserRoutingModule } from './pick-advertiser-routing.module';
import { PickAdvertiserComponent } from './pick-advertiser.component';
import { PickAdvertiserResolve } from './pick-advertiser.resolve';
import { NgxMaskModule, IConfig } from 'ngx-mask'

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        NgxMaskModule.forRoot(),
        SharedModule,
        PickAdvertiserRoutingModule
    ],
    declarations: [PickAdvertiserComponent],
    exports: [PickAdvertiserComponent],
    providers: [PickAdvertiserResolve]
})
export class PickAdvertiserModule {}
